import React, { forwardRef, useState } from "react";
import { useTranslation } from "react-i18next";
import Bowl from "../../imageComponents/bowl";
import Flat from "../../imageComponents/flat";
import Salads from "../../imageComponents/salad";
import Wrap from "../../imageComponents/wrap";
import Menu from "../../menu/menu.json";
import "./index.scss";
import FilterIcon from "../FilterIcon";
import Info from "../../imageComponents/info";
import {
  VegSticker,
  VeganSticker,
  ProteinSticker,
} from "../../imageComponents/diet_stickers";
import Vegan from "../../imageComponents/vegan";
import Protein from "../../imageComponents/protein";
import Img from "gatsby-image";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { graphql, useStaticQuery } from "gatsby";
import Vegetarian from "../../imageComponents/vegetarian";
import BowlSwooshes from "../../imageComponents/bowl_swooshes";
import FlatSwooshes from "../../imageComponents/flat_swooshes";
import SaladSwooshes from "../../imageComponents/salad_swooshes";
import WrapSwooshes from "../../imageComponents/wrap_swooshes";
import { Autoplay, Pagination, Navigation } from "swiper";

const Filters = {
  bowls: "bowls",
  flats: "flats",
  salads: "salads",
  wraps: "wraps",
};

const queryForMenuImages = graphql`
  query {
    allImageSharp(
      filter: {
        fluid: {
          originalName: {
            in: [
              "7_Caesar.jpg"
              "4_Salmon.jpg"
              "6_BLT.jpg"
              "1_Mediterranean.jpg"
              "2_NGK.jpg"
              "3_New-house.jpg"
              "5_Keto.jpg"
              "1_BBQ.jpg"
              "2_Salmon.jpg"
              "3_Cheesy.jpg"
              "1_Smart.jpg"
              "2_Mexican.jpg"
              "3_NGK.jpg"
              "4_Fresh.jpg"
              "1_Wrap-NGK.jpg"
              "2_Wrap-BBQ.jpg"
              "3_Wrap-Salmon.jpg"
              "4_Wrap-fresh.jpg"
              "7_Wrap-COBB.jpg"
              "6_Wrap-Caesar.jpg"
            ]
          }
        }
      }
    ) {
      nodes {
        fluid(maxHeight: 224) {
          originalName
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`;

const MenuSlide = ({ item, imageData, lang }) => {
  const getStickers = () => {
    let items = [];
    if (item.is_vegetarian) {
      items.push(<VegSticker />);
    } else if (items.is_vegan) {
      items.push(<VeganSticker />);
    }
    if (item.protein_boost) {
      items.push(<ProteinSticker />);
    }
    return items;
  };
  return (
    <>
      <Img fluid={imageData} height={224} width={392} />
      <div className="stickers">{[...getStickers()]}</div>
      <div className="menu-slide-info">
        <h2 className="desktop:desktop-h2 mobile:mobile-h2 tablet:mobile-h2">
          {item.name[lang]}
        </h2>
        <p className="desktop:desktop-body2 mobile:mobile-body2 tablet:mobile-body2">
          {item.description[lang]}
        </p>
      </div>
    </>
  );
};

const OurMenu = forwardRef((props, ref) => {
  let { t, i18n } = useTranslation();
  const result = useStaticQuery(queryForMenuImages);

  const { allImageSharp = {} } = result || {},
    { nodes = [] } = allImageSharp;
  let allImages = {};
  nodes.forEach((node) => {
    let { fluid = {} } = node || {},
      { originalName } = fluid;
    allImages[originalName] = fluid;
  });

  const [selectedFilter, setSelectedFilter] = useState(Filters.bowls);
  const changeFilter = (filter) => {
    setSelectedFilter(filter);
  };
  let selectedMenu = Menu[selectedFilter];
  selectedMenu = selectedMenu.filter((item) => !!item.name[i18n.language]);
  return (
    <div className="our-menu" id="our-menu" ref={ref}>
      <div className="menu-info-and-filter layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
        <div className="info">
          <h1 className="desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1">
            {t("ourMenu")}
          </h1>
          <p className="desktop:desktop-body1 mobile:mobile-body1 tablet:mobile-body1">
            {t("ourMenuInfo")}
          </p>
        </div>
        <div className="filter">
          <div
            className="filter-container"
            onClick={() => changeFilter(Filters.bowls)}
          >
            <FilterIcon
              selected={selectedFilter === Filters.bowls}
              Icon={Bowl}
              Swoosh={BowlSwooshes}
            />
            <p
              className={`desktop:desktop-action1 mobile:mobile-action1 tablet:mobile-action1 ${
                selectedFilter === Filters.bowls ? "selected" : ""
              }`}
            >
              {t(Filters.bowls)}
            </p>
          </div>
          <div
            className="filter-container"
            onClick={() => changeFilter(Filters.flats)}
          >
            <FilterIcon
              selected={selectedFilter === Filters.flats}
              Icon={Flat}
              Swoosh={FlatSwooshes}
            />
            <p
              className={`desktop:desktop-action1 mobile:mobile-action1 tablet:mobile-action1 ${
                selectedFilter === Filters.flats ? "selected" : ""
              }`}
            >
              {t(Filters.flats)}
            </p>
          </div>
          <div
            className="filter-container"
            onClick={() => changeFilter(Filters.salads)}
          >
            <FilterIcon
              selected={selectedFilter === Filters.salads}
              Icon={Salads}
              Swoosh={SaladSwooshes}
            />
            <p
              className={`desktop:desktop-action1 mobile:mobile-action1 tablet:mobile-action1 ${
                selectedFilter === Filters.salads ? "selected" : ""
              }`}
            >
              {t(Filters.salads)}
            </p>
          </div>
          <div
            className="filter-container"
            onClick={() => changeFilter(Filters.wraps)}
          >
            <FilterIcon
              selected={selectedFilter === Filters.wraps}
              Icon={Wrap}
              Swoosh={WrapSwooshes}
            />
            <p
              className={`desktop:desktop-action1 mobile:mobile-action1 tablet:mobile-action1 ${
                selectedFilter === Filters.wraps ? "selected" : ""
              }`}
            >
              {t(Filters.wraps)}
            </p>
          </div>
        </div>
      </div>
      <div className="menu-container">
        <div className="index layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
          <div className="index-heading">
            <Info />
            <p className="desktop:desktop-body3 mobile:mobile-body3 tablet:mobile-body3">
              {t("dietaryInformation")}
            </p>
          </div>
          <div className="dietary-info-container">
            <div className="dietary-info">
              <Vegetarian />
              <p className="desktop:desktop-body3 mobile:mobile-body3 tablet:mobile-body3">
                {t("vegetarian")}
              </p>
            </div>
            <div className="dietary-info">
              <Vegan />
              <p className="desktop:desktop-body3 mobile:mobile-body3 tablet:mobile-body3">
                {t("vegan")}
              </p>
            </div>
            <div className="dietary-info">
              <Protein />
              <p className="desktop:desktop-body3 mobile:mobile-body3 tablet:mobile-body3">
                {t("protienBoost")}
              </p>
            </div>
          </div>
        </div>
        <div className="menu layout desktop:container-desktop mobile:container-mobile tablet:container-mobile">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={0}
            pagination={{
              clickable: true,
            }}
            freeMode={true}
            navigation={true}
            mousewheel={true}
            cssMode={true}
            modules={[Autoplay, Pagination, Navigation]}
          >
            {selectedMenu.map((item, index) => {
              if (selectedMenu.length - 1 === index)
                return (
                  <SwiperSlide key={index} className="last-menu-item">
                    <div className="menu-slide">
                      <MenuSlide
                        item={item}
                        key={index}
                        imageData={allImages[item.image]}
                        lang={i18n.language}
                      />
                    </div>
                  </SwiperSlide>
                );
              return (
                <SwiperSlide key={index} className="menu-slide">
                  <MenuSlide
                    item={item}
                    key={index}
                    imageData={allImages[item.image]}
                    lang={i18n.language}
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
});

export default OurMenu;
